import { IdentifiedOnboardingGroup } from '@models/IdentifiedOnboardingGroup.model';
import { useContext, useMemo, useState } from 'react';
import { OnboardingFileContext } from '../../OnboardingFile.query';
import { GroupRow } from '../GroupRow/GroupRow';
import { MatchedItemWrapper } from '../MatchedItemWrapper/MatchedItemWrapper';
import { ProductMatchDetailsDialog } from '../ProductMatchDetailsDialog/ProductMatchDetailsDialog';
import {
  IdentifiedGroupWrapper,
  Title,
  ProductDetailsActionItem,
  RightColumn,
} from './IdentifiedGroupedFile.styles';

interface IIdentifiedGroupedFile {
  groups: IdentifiedOnboardingGroup;
}

export const IdentifiedGroupedFile = ({ groups }: IIdentifiedGroupedFile) => {
  const [openMatchDetails, setOpenMatchDetails] = useState(false);

  const { selectedProductId } = useContext(OnboardingFileContext);

  const productId = useMemo(() => {
    return groups.groups[0].items[0].productId;
  }, []);

  return (
    <IdentifiedGroupWrapper>
      <ProductMatchDetailsDialog
        open={openMatchDetails}
        onClose={() => setOpenMatchDetails(false)}
      />
      <MatchedItemWrapper
        title="Matched to:"
        fields={[
          { text: groups.matchedTo.split('::')[0] },
          { text: groups.matchedTo.split('::')[1] },
          { text: groups.matchedTo.split('::')[2] },
        ]}
      >
        <RightColumn>
          <ProductDetailsActionItem
            onClick={async () => {
              await selectedProductId.set(productId);
              setOpenMatchDetails(true);
            }}
          >
            Product Details
          </ProductDetailsActionItem>
          <div />
        </RightColumn>
      </MatchedItemWrapper>

      <Title>Your Details</Title>
      {groups.groups.map(group => {
        return <GroupRow key={group.id} group={group} />;
      })}
    </IdentifiedGroupWrapper>
  );
};
